<div class="d-flex flex-column">
    <app-profile-logo class="profile-logo"></app-profile-logo>

    <app-section-divider text="Info" [alignedText]="true"></app-section-divider>

    <app-profile-field
      class="info"
      fieldTitle="Role:"
      [value]="capitalizeFirstChar(user.role)"
      [largeField]="true"
      [disableEdit]="true"
    ></app-profile-field>

    <app-profile-field
      #businessNameInputField
      class="info"
      fieldTitle="Business name:"
      [value]="profile.businessName"
      [largeField]="true"
      [onSave]="saveBusinessName.bind(this)"
      addressType="establishment"
      [objectToString]="businessNameToString"
      [disableEdit]="(disableFieldEdit$ | async)!"
    ></app-profile-field>

    <app-profile-field
      [value]="profile.address"
      class="info"
      fieldTitle="Business address:"
      [largeField]="true"
      [onSave]="saveAddress.bind(this)"
      addressType="address"
      [objectToString]="addressToString"
      [disableEdit]="(disableFieldEdit$ | async)!"
    ></app-profile-field>

    <app-profile-field
      class="info"
      fieldTitle="Business phone number:"
      inputmode="tel"
      [value]="profile.phoneNumber"
      [largeField]="true"
      (onChange)="phoneNumberSubject.next($event)"
      [onSave]="saveBusinessPhoneNumber.bind(this)"
      mask="(000) 000-0000"
      [alternativeEdit]="(disableFieldEdit$ | async)!"
      (onEdit)="onBusinessPhoneNumberEditClick()"
      [initialError]="phoneNumberError"
      [disableEdit]="(disableFieldEdit$ | async)!"
    ></app-profile-field>

    <ng-container *ngIf="(quickbooksService.currentState$ | async) let qbState">

        <ng-container *ngIf="!qbState.permissionDenied">
            <app-section-divider text="Quickbooks" class="mt--24 mb--24" [alignedText]="true"></app-section-divider>

            <div class="qb-block">
                <div class="title">Connection:</div>
                <loader-button [loading]="qbAuthLoading" text="Connect"
                               (click)="connectQb()" *ngIf="!qbState.hasAccess"
                ></loader-button>
                <div class="d-flex align-items-center gap--16" *ngIf="qbState.hasAccess">
                    <div class="value">
                        Connected
                    </div>
                    <loader-button [loading]="qbTestApiLoading" text="Test QB API"
                                   (click)="testQBApi()"
                    ></loader-button>
                    <loader-button [loading]="false" text="Disconnect"
                                   (click)="disconnectQb()" color="warn"
                    ></loader-button>
                </div>
            </div>
            <div class="qb-block" *ngIf="qbState.expiryDate">
                <div class="title">Access {{ qbState.hasAccess ? 'expires' : 'expired' }} at:</div>
                <div class="value">
                    {{ qbState.expiryDate | date: 'MM/dd/yyyy, h:mm a' }}
                </div>
            </div>
        </ng-container>

    </ng-container>

    <ng-container *ngIf="showNuveiData$ | async let data">

        <app-section-divider text="Nuvei" class="mt--24 mb--24" [alignedText]="true"><h4 *ngIf="(status$ | async) === 'approved'">&nbsp;-&nbsp;<span class="connected">Connected</span></h4></app-section-divider>

        <app-banner *ngIf="data.dataType === 'banner'" [type]="data.type" class="ml--8 mr--8 mb--16">
            <div *ngIf="((status$ | async) === 'missing_data') else notMissingData" content>
                <p style="font-weight: 600">More information is required:</p>
                <ul class="mt--16 mb--16">
                    <li style="font-weight: 500; margin-bottom: 8px; white-space: break-spaces;" *ngFor="let item of missingDataList$ | async">{{item}}</li>
                </ul>
                <p style="font-weight: 500" (click)="data.action!.fn()">Please gather the required information and provide it via the <span class="simple-text-button">Support ></span></p>
            </div>
            <ng-template #notMissingData>
                <p content class="banner-text">{{data.message}}</p>
            </ng-template>
            <p *ngIf="data.action" trailing [class]="'simple-text-button ' + data.action.class" (click)="data.action.fn()">{{ data.action.text }}</p>
        </app-banner>

        <app-profile-field *ngIf="data.dataType === 'nuvei_data'"
            class="info"
            [disableEdit]="true"
            fieldTitle="Bank account number:"
            [value]="data.bankAccountNumber"
        ></app-profile-field>

    </ng-container>

</div>